import React from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import MembershipPoolShow from './MembershipPoolShow';
import { fetchMembershipPool } from 'store/actions/membership-pools/fetchMembershipPools';

const MembershipPoolShowContainer = (props) => {
    const {
        data,
        history,
        id,
        resource,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <MembershipPoolShow
            history={ history }
            id={ id }
            record={ data }
            resource={ resource }
        />
    );
};

MembershipPoolShowContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'membership-pools',
    action: fetchMembershipPool,
};

export default fetchResourceById(fetchValues)(MembershipPoolShowContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-pools/show/MembershipPoolsShowContainer.js